// extracted by mini-css-extract-plugin
export default {"wrapper":"GuestSection_wrapper__E6UrH","heading":"GuestSection_heading__hSngu","body":"GuestSection_body__KAn7Q"};